<template>
<div class="card">
    <div class="card-body">
        <div class="prescription-update">
            <div class="mb-3">
                <p>Please update the status of prescription preparation here.</p>
                <p>Current status is <b>{{status}}</b></p>
            </div>
            <form data-vv-scope="prescription-status" @submit.prevent="submitForm">
                <div class="form-row">
                    <div class="form-group col">
                        <label>Prescription Status</label>
                        <select name="selectStatus" data-vv-as="prescription status" v-validate="validateDropdownStatus" v-model="value.statusId" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('prescription-status.selectStatus')
                            }">
                            <option v-for="(status, index) in prescriptionStatusSelect" :key="index" :value="status.value">
                                {{status.text}}
                            </option>
                        </select>

                        <div v-show="validationErrors.has('prescription-status.selectStatus')" class="invalid-feedback">
                            {{ validationErrors.first('prescription-status.selectStatus') }}
                        </div>
                    </div>
                </div>

                <template v-if="value.statusId === 4">
                    <div class="form-row">
                        <div class="form-group col">
                            <label>Delivery Provider</label>
                            <input name="deliveryProvider" data-vv-validate-on="blur"
                                data-vv-as="delivery provider" v-validate="'required'" v-model="value.deliveryProvider" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('prescription-status.deliveryProvider')
                                }" />

                            <div v-show="validationErrors.has('prescription-status.deliveryProvider')" class="invalid-feedback">
                                {{ validationErrors.first('prescription-status.deliveryProvider') }}
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col">
                            <label>Delivery Tracking Code (if available)</label>
                            <input name="deliveryTracking" v-model="value.trackingCode" :class="{
                                'form-control': true
                                }" />
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col">
                            <label>Delivery Tracking Web Address (if available)</label>
                            <input name="trackingUrl" v-model="value.trackingUrl" v-validate="'url'" data-vv-as="delivery tracking web address" data-vv-validate-on="blur" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('prescription-status.trackingUrl')
                                }" />
                            <div v-show="validationErrors.has('prescription-status.trackingUrl')" class="invalid-feedback">
                                {{ validationErrors.first('prescription-status.trackingUrl') }}
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col">
                            <label>Medicine Parcel Photo</label>
                            <div>
                                <input id="uploadFileInput" type="file" v-validate="'mimes:image/*|size:5120'" data-vv-as="delivery parcel photo" name="deliveryParcelPhoto"
                                    :class="{'is-invalid':  validationErrors.has('prescription-status.deliveryParcelPhoto')}">
                                <div v-show="validationErrors.has('prescription-status.deliveryParcelPhoto')" class="invalid-feedback">
                                    {{ validationErrors.first('prescription-status.deliveryParcelPhoto') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </form>
            <slot></slot>
        </div>
    </div>
</div>

</template>

<script>
export default {
    'name': 'PrescriptionStatusUpdateComponent',
    'props': {
        'value': Object,
        'status': null,
        'statusId': 0
    },
    'computed': {
        availableStatuses () {
            if (this.statusId === 1000) {
                return this.prescriptionStatusSelect;
            }

            return this.prescriptionStatusSelect.filter(s => s.value > this.statusId);
        },
        validateDropdownStatus () {
            let values = this.availableStatuses.map(a => a.value).join(',');

            return `required|included:${values}`;
        }
    },
    mounted () {
        if (!this.value.deliveryProvider) { this.value.deliveryProvider = 'Pos Laju'; };
    },
    data () {
        return {
            'prescriptionStatusSelect': [
                {
                    'text': 'In Preparation',
                    'value': 3
                },
                {
                    'text': 'Delivered',
                    'value': 4
                }
            ]
        };
    },
    'methods': {
        submitForm () {
            return this.$validator.validateAll('prescription-status');
        }
    }
};
</script>

<style>

</style>
